import './AvatarGroup.css';
export var avatarGroupItemWrapper = '_129un530-3-15-1';